/** Name of the feature. */
export const StandardDisconnect = 'standard:disconnect';
/**
 * @deprecated Use {@link StandardDisconnect} instead.
 *
 * @group Deprecated
 */
export const Disconnect = StandardDisconnect;
//# sourceMappingURL=disconnect.js.map